import { DestroyRef, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

export const isNil = (val: unknown) => val === null || val === undefined;

export const isEmpty = (val: unknown) =>
  isNil(val) || (typeof val === 'string' && val.length === 0);

export const untilDestroyed = () => {
  const subject = new Subject();

  inject(DestroyRef).onDestroy(() => {
    subject.next(true);
    subject.complete();
  });

  return <T>() => takeUntil<T>(subject.asObservable());
};

export const formatDate = (timestamp: number | Date) => {
  const locale = navigator.language ?? 'en-GB';
  const dt = Intl.DateTimeFormat(locale, {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'Africa/Nairobi'
  });
  try {
    return dt.format(timestamp);
  } catch (e) {
    console.error(e);
    return dt.format(Date.now());
  }
};

export const macroTasking = (fn: () => void, delay = 0) => {
  setTimeout(fn, delay);
};
